/**
 * Service for generating and transmitting GA virtual page views
 */

import _ from 'lodash';

export default {
  /**
  * Tracks a virtual page view using the window.dataLayer object provided by Google Tag Manager
  *
  * @param {string} trackedURL The virtual page view URL to track
  */
  trackPageView(trackedURL) {
    let dataLayer = window.dataLayer;
    if (dataLayer) {
      const pageView = _.extend({
        event: 'virtualPageview',
        virtualPageURL: trackedURL
      });
      dataLayer.push(pageView);
    }
    return trackedURL;
  }

}



// WEBPACK FOOTER //
// ./src/services/AnalyticsService.js